<app-service-find-by-id-container *ngIf="id" [service]="service" [id]="id">
    <ng-template let-entity='entity' template-content>
        <app-document-summary-field [documentSummary]="entity"></app-document-summary-field>
    </ng-template>
</app-service-find-by-id-container>